import apiV2 from '~/utils/apiV2'

export const actions = {
  async requestRss() {
    try {
      const { data } = await this.$axiosV2.get(apiV2.pages.getRss())

      return data
    } catch (e) {
      throw e
    }
  }
}
